import { Component, OnInit, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppDataService } from '../../core/services/app-data.service';
import { ReportService } from '../../core/services/report.service';
import { ExportService } from '../../core/services/export.service';
import { EquipmentService } from '../../core/services/equipment.service';
import { formatCurrency, formatDate } from '../../core/utils/format.util';
import { environment } from '../../environments/environment';
import { ReportDateRangeComponent } from '../report-date-range/report-date-range.component';
import { ReportDateRangeService } from '../../report-date-range.service';

@Component({
  selector: 'app-damaged-equipment-report',
  standalone: true,
  imports: [RouterLink, ReportDateRangeComponent],
  templateUrl: './damaged-equipment.component.html',
  styleUrl: './../../report-shared.css',
})
export class DamagedEquipmentReportComponent implements OnInit {
  private readonly appData = inject(AppDataService);
  private readonly reports = inject(ReportService);
  private readonly equipment = inject(EquipmentService);
  private readonly exporter = inject(ExportService);
  protected readonly dateRange = inject(ReportDateRangeService);
  protected readonly formatCurrency = formatCurrency;
  protected readonly formatDate = formatDate;

  private readonly range = computed(() => ({
    startDate: this.dateRange.appliedStartDate(),
    endDate: this.dateRange.appliedEndDate(),
  }));

  protected readonly records = computed(() =>
    this.reports.getDamagedEquipmentReport(this.range()),
  );

  ngOnInit(): void {
    if (!environment.useMockData) {
      this.appData.refreshAll();
    }
  }

  protected statusClass(damageType: string, status: string): string {
    if (damageType === 'lost') {
      return 'write-off';
    }
    if (status === 'under-review') {
      return 'in-repair';
    }
    return 'maintenance';
  }

  protected statusLabel(damageType: string, status: string): string {
    if (damageType === 'lost') {
      return 'Write-Off';
    }
    if (status === 'under-review') {
      return 'In Repair';
    }
    return 'Maintenance';
  }

  exportData(): void {
    this.exporter.downloadCsv(
      `damaged-equipment-report-${new Date().toISOString().slice(0, 10)}`,
      this.records().map((row) => ({ ...row })),
    );
  }
}
